import { render, staticRenderFns } from "./contentCourseCertificateAdd.vue?vue&type=template&id=82a9898a&"
import script from "./contentCourseCertificateAdd.vue?vue&type=script&lang=js&"
export * from "./contentCourseCertificateAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports